import { AppConstants } from '../shared/app.constants';
import { AuthService } from '../auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
var PotentialService = /** @class */ (function () {
    function PotentialService(appConstants, auth, http) {
        this.appConstants = appConstants;
        this.auth = auth;
        this.http = http;
    }
    PotentialService.prototype.getAllPotentials = function () {
        var url = environment.apiBase + 'potentials';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    PotentialService.prototype.approvePotential = function (potentialId) {
        var url = environment.apiBase + ("user/" + potentialId + "/potentials");
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, {}, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    PotentialService.prototype.rejectPotential = function (potentialId) {
        var url = environment.apiBase + ("potentials/" + potentialId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.delete(url, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    PotentialService.prototype.getPotential = function (potentialId) {
        var url = environment.apiBase + ("potential/" + potentialId);
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return PotentialService;
}());
export { PotentialService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/potential.service.ts.pre-build-optimizer.js